import { backdrops } from './data/data.backdrops';

export const tool = {
  name: 'environment',
  description:
    'A tool that changes the environment settings, such as grid lines, lighting, background, and backdrop.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      areGridLinesVisible: {
        type: 'boolean',
        description: 'Whether grid lines are visible.',
      },
      gridLinesOpacity: {
        type: 'number',
        minimum: 0,
        maximum: 1,
        description: 'Opacity of grid lines from 0 to 1.',
      },
      gridLinesColor: {
        type: 'string',
        pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$',
        description: 'Color of grid lines in hex format.',
      },
      lightColor: {
        type: 'string',
        pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$',
        description: 'Color of the environment light in hex format.',
      },
      lightIntensity: {
        type: 'number',
        minimum: 0,
        maximum: 6,
        description: 'Light intensity from 0 to 6.',
      },
      backgroundColor: {
        type: 'string',
        pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$',
        description: 'Background color in hex format.',
      },
      backgroundIntensity: {
        type: 'number',
        minimum: 0,
        maximum: 1,
        description: 'Background light intensity from 0 to 1.',
      },
      backdropEnabled: {
        type: 'boolean',
        description: 'Whether a backdrop is enabled.',
      },
      backdropId: {
        type: 'string',
        enum: backdrops,
        description: 'ID of the backdrop to use if enabled.',
      },
      backdropGrainIntensity: {
        type: 'number',
        minimum: 0,
        maximum: 1,
        description: 'Intensity of the grain effect on the backdrop from 0 to 1.',
      },
      message: {
        type: 'string',
        default: 'Update environment settings',
      },
    },
    required: ['message'],
  },
};
